module.exports = __webpack_public_path__ + "static/024-e5b19f648de521ec05b0e0a9141e1a85.jpg";